import type { EventQueueRowData } from '../socket/stream-types';
import type { GeoPoint } from './types';
import { getHaversineDistanceBetweenTwoEntities, isValidLatLng } from './helpers';

function getEventLocation(event: EventQueueRowData): GeoPoint {
    return { latitude: event.latitude!, longitude: event.longitude! };
}

export function getDistanceFromEvent(
    event: EventQueueRowData,
    unitLocation: GeoPoint
): number | undefined {
    const isValidLocation = isValidLatLng(event.latitude, event.longitude);
    if (isValidLocation) {
        return getHaversineDistanceBetweenTwoEntities({
            firstEntityCoordinates: unitLocation,
            secondEntityCoordinates: getEventLocation(event),
        });
    }
}

export function injectDistanceFromEvent(
    rows: EventQueueRowData[],
    unitLocation?: GeoPoint | null
): EventQueueRowData[] {
    for (const row of rows) {
        row.distanceFromEvent = unitLocation ? getDistanceFromEvent(row, unitLocation) : undefined;
    }
    return rows;
}
